import { getClient as e, registerEntityEndpoint as t } from "@editor/ui-utils";
var n = t("video-page"), { getEntity: r, listEntities: i, putEntity: a, postEntity: o, deleteEntity: s } = n, c = async (e) => r(e), l = async (e) => {
	let { _id: t, createDate: n, changeDate: r, isDeleted: i, brand: a, deleteDate: s, legacy: c, paths: l, ...u } = e;
	return o(u);
}, u = async (e, t) => {
	let { _id: n, createDate: r, changeDate: i, isDeleted: o, brand: s, deleteDate: c, initialPublishedTitle: l, initialPublishDate: u, legacy: d, paths: f, channelPath: p, secondaryChannelsPath: m, channelUuidsWithSecondary: h, channelPathWithSecondary: g, ..._ } = t;
	return a(e, _);
}, d = async (e) => s(e), f = () => ({
	_id: "",
	createDate: /* @__PURE__ */ new Date(),
	changeDate: /* @__PURE__ */ new Date(),
	title: "",
	brand: "bunte",
	state: "draft",
	slug: "",
	seoTitle: "",
	seoDescription: "",
	isTeaserDataShown: !1,
	channelUuid: "",
	markAsAd: !1,
	hideFromTeaserList: !1,
	isNoIndex: !1,
	isAdsEnabled: !0,
	updateShownDate: !1,
	videoUuid: "",
	bfJobUuid: "",
	paths: [],
	isDeleted: !1,
	legacy: {
		source: "vibe",
		isEditableInCTF: !0,
		isRenderedByCTF: !0,
		hasBeenModifiedInCTF: !0
	}
}), p = async (t) => (await e().get(`/cms/video-page/${t}/check-path-conflict`)).data, m = (e, t) => {
	let n = e.__vccOpts || e;
	for (let [e, r] of t) n[e] = r;
	return n;
};
//#endregion
export { d as a, u as c, l as i, n, f as o, p as r, c as s, m as t };

//# sourceMappingURL=_plugin-vue_export-helper-CAW4dcA9.js.map